var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "u-clear" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-fl field large" },
      [
        _c("label", { staticClass: "label" }, [_vm._v("Width")]),
        _vm._v(" "),
        _c("ui-number", {
          attrs: { value: _vm.active.width },
          on: {
            change: function($event) {
              return _vm.resize("width", $event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-fl field large" },
      [
        _c("label", { staticClass: "label" }, [_vm._v("Height")]),
        _vm._v(" "),
        _c("ui-number", {
          attrs: { value: _vm.active.height },
          on: {
            change: function($event) {
              return _vm.resize("height", $event)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [_c("p", [_vm._v("Canvas")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }